import React from 'react';
import styled from 'styled-components';
import * as colors from '../../util/colors';
import RateTile from './RateTile';
import DosingDetailTile from './DosingDetailTile';

const StyledCard = styled.div`
    --componentBreakpoint: 900px;
    --multiplier: (var(--componentBreakpoint) - 100%);
    --basis: calc(var(--multiplier) * 999);
    --bg: ${({ bgColor }) =>
        bgColor === 'gradient'
            ? `radial-gradient(circle at 23% 0, #006ead, #35864b 67%, #36864a 87%)`
            : `linear-gradient(139deg, #444444 11%, #696969 88%)`};

    border: 1px solid ${colors.silver};
    border-radius: 8px;
    overflow: hidden;
    display: flex;
    flex-wrap: wrap;
    flex: 1;

    > * {
        flex: 1 1 280px;
    }
`;

const Card = ( props ) => {
    //if the label says 'Keytruda', make the box theme green
    const bgColor =  'gradient';
    return (
        <StyledCard bgColor={bgColor}>
            <RateTile {...props} />
            <DosingDetailTile {...props} bgColor={bgColor}/>
        </StyledCard>
    );
};

export default Card;
